const API_ENDPOINT = "https://marisubackend-production.up.railway.app/api/";
// const API_ENDPOINT = "http://127.0.0.1:8000/api/";
const API_ROUTES = {
  SIGN_UP: `${API_ENDPOINT}register/`,
  SIGN_IN: `${API_ENDPOINT}login/`,
  VERIFY_OTP: `${API_ENDPOINT}verify/`,
  HOSTELS: `${API_ENDPOINT}hostels/`,
  HOSTEL: `${API_ENDPOINT}hostels/`,
  BOOKINGS: `${API_ENDPOINT}bookings/`,
  BOOKING: `${API_ENDPOINT}bookings/`,
  REFRESH: `${API_ENDPOINT}token/refresh/`,
  USERS: `${API_ENDPOINT}users/`,
  LOGOUT: `${API_ENDPOINT}logout/`,
  SEARCH: `${API_ENDPOINT}hostels/search/`
};

export default API_ROUTES;